
import React, { useEffect, useState } from "react";
import img2 from "../assets/Fingenius/ADA.png";
import img3 from "../assets/Fingenius/BNB.png";
import img4 from "../assets/Fingenius/BTC.png";
import img5 from "../assets/Fingenius/DOGE.png";
import img6 from "../assets/Fingenius/ETH.png";
import img7 from "../assets/Fingenius/GALA.png";
import img8 from "../assets/Fingenius/MANA.png";
import img9 from "../assets/Fingenius/OCEAN.png";
import img10 from "../assets/Fingenius/SOL.png";
import img11 from "../assets/Fingenius/XRP.png";

const formatPrice = (price) => {
  const parsedPrice = parseFloat(price);
  const decimalPlaces = parsedPrice % 1 === 0 ? 0 : 4;
  return parsedPrice.toFixed(decimalPlaces);
};

function WebsocketApi() {
  const [tableData, setTableData] = useState([]);
  const [retryCount, setRetryCount] = useState(0);

  const exchangeImageMapping1 = {
    ADA: { image: img2, fullname: "(Cardano)" },
    BNB: { image: img3, fullname: "(Binance Coin)" },
    BTC: { image: img4, fullname: "(Bitcoin)" },
    DOGE: { image: img5, fullname: "(Dogecoin)" },
    ETH: { image: img6, fullname: "(Ethereum)" },
    GALA: { image: img7, fullname: "(Gala)" },
    MANA: { image: img8, fullname: "(Decentraland)" },
    OCEAN: { image: img9, fullname: "(Ocean Protocol)" },
    SOL: { image: img10, fullname: "(Solana)" },
    XRP: { image: img11, fullname: "(XRP)" },
  };

  useEffect(() => {
    const connectWebSockets = () => {
      const symbols = [
        "btcusdt",
        "bnbusdt",
        "manausdt",
        "oceanusdt",
        "solusdt",
        "dogeusdt",
        "ethusdt",
        "adausdt",
        "xrpusdt",
        "galausdt",
        "usdtusd",
        
      ];
      const symbolStreamsTrades = symbols
        .map((symbol) => `${symbol}@trade`)
        .join("/");
      const symbolStreamsTickers = symbols
        .map((symbol) => `${symbol}@ticker`)
        .join("/");

      const socketEndpointFuturesTrades = `wss://fstream.binance.com:443/stream?streams=${symbolStreamsTrades}`;
      const socketEndpointSpotTickers = `wss://stream.binance.com:9443/stream?streams=${symbolStreamsTrades}`;

      const socketFuturesTrades = new WebSocket(socketEndpointFuturesTrades);
      const socketSpotTickers = new WebSocket(socketEndpointSpotTickers);

      socketFuturesTrades.onopen = () => {
        console.log("WebSocket connection for futures trades established.");
      };

      socketSpotTickers.onopen = () => {
        console.log("WebSocket connection for spot tickers established.");
      };

      socketFuturesTrades.onerror = (error) => {
        console.error("WebSocket error for futures trades:", error);
        reconnectWebSockets();
      };

      socketSpotTickers.onerror = (error) => {
        console.error("WebSocket error for spot tickers:", error);
        reconnectWebSockets();
      };

      socketFuturesTrades.onmessage = (event) => {
        handleIncomingData(event, 'futures');
      };

      socketSpotTickers.onmessage = (event) => {
        handleIncomingData(event, 'spot');
      };

      socketFuturesTrades.onclose = () => {
        console.warn("WebSocket connection for futures trades closed. Reconnecting...");
        reconnectWebSockets();
      };

      socketSpotTickers.onclose = () => {
        console.warn("WebSocket connection for spot tickers closed. Reconnecting...");
        reconnectWebSockets();
      };

      const handleIncomingData = (event, marketType) => {
        try {
          const data = JSON.parse(event.data);
          // console.log("Received data kkk:", data);
          const tickers = data.data;
          const coinName = tickers.s.replace("USDT", "");


          
          setTableData((prevData) => {
            const existingCoin = prevData.find((coin) => coin.name === coinName);
            if (existingCoin) {
              return prevData.map((coin) =>
                coin.name === coinName
                  ? {
                      ...coin,
                      price: marketType === 'futures' ? tickers.p : coin.price,
                      newprice: marketType === 'spot' ? tickers.p : coin.newprice,
                      marketType, // Adding market type to differentiate in the UI
                    }
                  : coin
              );
            } else {
              const coinFullName =
                exchangeImageMapping1[coinName]?.fullname || coinName;
              return [
                ...prevData,
                {
                  name: coinName,
                  fullname: coinFullName,
                  price: marketType === 'futures' ? tickers.p : '',
                  newprice: marketType === 'spot' ? tickers.P : '',
                  marketType,
                },
              ];
            }
          });
        } catch (error) {
          console.error(`Error parsing ${marketType} message:`, error);
        }
      };

      const reconnectWebSockets = () => {
        if (retryCount < 5) {
          setRetryCount((prevCount) => prevCount + 1);
          setTimeout(connectWebSockets, 2000); // Retry after 2 seconds
        } else {
          console.error("Max retries reached. Unable to connect to WebSocket.");
        }
      };
    };

    connectWebSockets();

    return () => {
      setRetryCount(0); // Reset retry count on component unmount
    };
  }, [retryCount]);

  const filteredTableData = tableData.filter(
    (coin) => exchangeImageMapping1[coin.name]
  );

  const sortedTableData = filteredTableData?.sort((a, b) => b.price - a.price);

  return sortedTableData;
}

export default WebsocketApi;
